import { accessRole } from "../../../../../helpers/access_role";
import { config } from "../../../../../helpers/config_global";
// import  "../../../../../helpers/ui/BlinkStyle.css";
import React, { useState, Component, Fragment } from "react";
import SimulationComponent from "../../../PresensiAdmin/Detail/Components/SimulationComponent";
import { Redirect } from "react-router-dom";

import {
  Tooltip,
  Row,
  Col,
  Label,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";

import MKIDatatable from "../../../../../modules/mki-datatable/lib";
import { ConfirmAlert } from "../../../../../helpers/ui/alert";

import { cancelToken } from "../../../../../services/adapters/kepegawaian/menuService";

import DataTableBloc from "../Blocs/DataTableBloc";
import apiResponse from "../../../../../services/apiResponse";

import moment from "moment";
// import { parseInt } from "lodash";
import Shimmer from "react-shimmer-effect";
import { AvForm, AvField } from "availity-reactstrap-validation";
import Select from "../../../../../helpers/ui/CustomSelect";
import { generateFormData } from "../../../../../helpers/ui/FileInput";

class TablePenilaianBawahanComponent extends Component {
  dataTableBloc = new DataTableBloc();

  source;
  historyMonth = "penilaian_history_month_tunsus"; //
  historyYear = "penilaian_history_year_tunsus"; //
  historyTable = "historypenilaianTunjanganKhususTableActive"; // Nama di tiap tabel harus beda karena akan disimpan di session
  defaultOrder = "special_allowance_summary_id"; // orderBy
  defaultSize = 10;
  defaultSort = "desc";
  configDatatable = {
    ...config("datatable"),
    sort: {
      column: this.defaultOrder,
      order: this.defaultSort,
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      modalPresensi: false,
      modalPresensiUuid: null,
      modalPresensiFilter: null,
      selectedPositionSKP: "",
      selectedPositionUuid: "",
      selectedPositionName: "",
      selectedEmployeeName: "",
      selectedEmployeeNip: "",
      updatePositionUuid: null,
      deletePositionUuid: null,
      submitType: null,

      modal: false,
      categories: [
        "9d05d51a-a28d-42e5-9938-21e8640f1a67", // STAFF KHUSUS
        "70e4cc97-56bd-4d22-bc75-363b13eaff82", // INTERNAL POLRI
        "81c7fc7f-08b6-4781-8ce3-b3e55ce03fa9", // INTERNAL TNI
        "a1db6606-5a44-4d59-ac7a-d1c8a4b624e3", // KOHLI
      ],
      positions: ["516f3bd6-e9bb-462d-8e00-bf04b93406b8"],
      tooltip: false,
      createUuid: null,
      updateUuid: null,
      previewUuid: null,
      inactiveUuid: null,
      activeUuid: null,
      defaultSize: 10,
      rows: [],
      positionOptions: [],
      totalRow: 0,
      loadingTable: true,
      loadingPosition: true,
      runType: null,
      confirmInfo: "Apakah anda yakin akan melakukan verifikasi tunkin?",
      roleId: localStorage.getItem("currentRoleId"),
      filter: sessionStorage.getItem(this.historyTable)
        ? JSON.parse(sessionStorage.getItem(this.historyTable))
        : {
          filter_value: "",
          page_number: 1,
          page_size: this.defaultSize,
          sort_order: {
            column: this.defaultOrder,
            order: this.defaultSort,
          },
        },
    };
  }
  toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });
  dateParse = (input) => {
    let res = "";
    if (input !== "" && input != null) {
      res = moment(input).format("DD/MM/YYYY");
    }
    return res;
  };

  loadData = async () => {
    /* history Datatable */
    sessionStorage.setItem(
      this.historyTable,
      JSON.stringify(this.state.filter)
    );

    localStorage.setItem(
      this.historyMonth,
      JSON.stringify(this.props.additionalFilter.month)
    );

    localStorage.setItem(
      this.historyYear,
      JSON.stringify(this.props.additionalFilter.year)
    );

    /* kirim ke server */
    let offset =
      (this.state.filter.page_number - 1) * this.state.filter.page_size;
    if (this.state.defaultSize !== this.state.filter.page_size) {
      this.setState({
        defaultSize: this.state.filter.page_size,
      });
      offset = 0;
      this.configDatatable.page_number = 1;
    }
    const query = {
      search: this.state.filter.filter_value,
      limit: this.state.filter.page_size,
      offset: offset,
      order: this.state.filter.sort_order.column,
      sort: this.state.filter.sort_order.order,
      status: 1,
      roleId: this.state.roleId,
      is_echelon: this.props.additionalFilter.is_eselon,
      is_eselon: this.props.additionalFilter.is_eselon,
      ...this.props.additionalFilter,
    };

    // console.log(query)
    // console.log("configValue : " + this.state.configValue);
    // console.log("configPenilaian : " + this.props.additionalFilter.configPenilaian);
    // console.log("is_eselon : " + this.props.additionalFilter.is_eselon);
    // console.log("statusVerifikasi : " + this.props.additionalFilter.statusVerifikasi);
    await this.dataTableBloc.fetchRowTable(query, this.source.token);
  };

  loadPosition = async () => {
    const query = {
      status: 1,
    };
    await this.dataTableBloc.fetchPosition(query, this.source.token);
  };

  setTokenAPI = () => {
    if (typeof this.source != typeof undefined) {
      this.source.cancel();
    }
    this.source = cancelToken();
    // console.log('xxxx');
    // console.log(this.props.loading)
    // debugger;
    // console.log(
    //   "loadingTableAtasan : " + this.props.loading.loadingTableAtasan
    // );
    // console.log("loadingDetail  : " + this.props.loading.loadingDetail);
    this.loadData();
    this.loadPosition();

    // if (
    //   this.props.loading.loadingTableAtasan == false &&
    //   this.props.loading.loadinDetail == false
    // ) {
    // }
  };

  handlerOnSubmit = (e, values) => {
    // debugger;
    e.preventDefault();
    this.setState({
      dataForm: {
        ...values,
      },
      confirm: true,
    });
  };

  updatePosition = async () => {
    let formData = generateFormData();
    formData.append("uuid", this.state.updatePositionUuid);
    formData.append("position_uuid", this.state.selectedPositionUuid);
    await this.dataTableBloc.updatePosition(formData);
  };

  deleteData = async () => {
    let formData = generateFormData();
    formData.append("special_uuid", this.state.special_uuid);
    formData.append("summary_uuid", this.state.summary_uuid);
    await this.dataTableBloc.deleteTunsus(formData);
  };

  clearData = async () => {
    let formData = generateFormData();
    formData.append("uuid", this.state.special_uuid);
    await this.dataTableBloc.fetchClearSpecialAllowance(formData);
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
          modal: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
          modal: false,
        };
        if (this.state.submitType == 1) {
          this.updatePosition();
        } else if (this.state.submitType == 2) {
          this.deleteData();
        } else if (this.state.submitType == 3) {
          this.clearData();
        }

        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
          modal: false,
        };
        break;
      case "failed":
        forState = {
          failed: false,
          modal: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  // confirmResponse = (response) => {
  //   let forState = {};
  //   switch (response) {
  //     case "cancel":
  //       forState = {
  //         confirm: false,
  //       };
  //       break;
  //     case "confirm":
  //       forState = {
  //         loading: true,
  //         confirm: false,
  //       };
  //       break;
  //     case "success":
  //       forState = {
  //         success: false,
  //         redirect: true,
  //       };
  //       break;
  //     case "failed":
  //       forState = {
  //         failed: false,
  //       };
  //       break;
  //     default:
  //   }
  //   this.setState(forState);
  // };

  inactiveData = async () => {
    await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid });
  };
  activeData = async () => {
    await this.dataTableBloc.fetchActive({ uuid: this.state.activeUuid });
  };

  handleButtonExport = () => {
    // alert('ooooooooooooooo')
    this.dataTableBloc.fetchExport({
      month: this.props.additionalFilter.month,
      year: this.props.additionalFilter.year,
    });
  };

  toggleModal = () => this.setState({ modal: !this.state.modal });

  componentDidMount() {
    this.setTokenAPI();

    this.dataTableBloc.rowtableChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingTable: false,
          });
          break;
        case apiResponse.LOADING:
          this.setState({
            loadingTable: true,
          });
          break;
        case apiResponse.COMPLETED:
          const response = result.data.response;
          this.setState({
            totalRow: response.total,
            rows: response.result,
            loadingTable: false,
          });
          // this.props.onConfigChange(this.state.loadingTable);

          this.props.setDocument(response?.document);
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.dataTableBloc.listPositionChannel.subscribe((result) => {
      switch (result.status) {
        // case apiResponse.INITIAL:
        //   this.setState({
        //     loadingTable: false,
        //   });
        //   break;
        case apiResponse.LOADING:
          this.setState({
            loadingPosition: true,
          });
          break;
        case apiResponse.COMPLETED:
          const response = result.data.response;
          this.setState({
            // totalRow: response.total,
            positionOptions: response.result,
            loadingPosition: false,
          });
          // this.props.onConfigChange(this.state.loadingTable);

          this.props.setDocument(response?.document);
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.dataTableBloc.updatePositionChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState(
            {
              loading: false,
              success: true,
            },
            function () {
              this.setTokenAPI();
            }
          );
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    this.dataTableBloc.deleteTunsusChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState(
            {
              loading: false,
              success: true,
            },
            function () {
              this.setTokenAPI();
            }
          );
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    this.dataTableBloc.clearPenilaianChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState(
            {
              loading: false,
              success: true,
            },
            function () {
              this.setTokenAPI();
            }
          );
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    this.dataTableBloc.exportChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          this.setState({
            loading: true,
          });
          break;
        case apiResponse.COMPLETED:
          const link = result.data.response;
          window.open(link.file_url, "_blank");
          //window.location.href = link.file_url
          this.setState({
            loading: false,
            success: true,
          });
          setTimeout(() => {
            this.setState({
              success: false,
            });
          }, 1000);
          break;
        case apiResponse.ERROR:
          this.setState({
            urlFileDetail: link,
            loading: false,
            failed: true,
          });
          setTimeout(function () {
            this.setState({
              failed: false,
            });
          }, 1000);
          break;
        default:
          break;
      }
    });
  }

  componentWillUnmount() {
    this.dataTableBloc.rowtableChannel?.unsubscribe();
    this.dataTableBloc.listPositionChannel?.unsubscribe();
    this.dataTableBloc.updatePositionChannel?.unsubscribe();
    this.dataTableBloc.deleteTunsusChannel?.unsubscribe();
    this.dataTableBloc.exportChannel?.unsubscribe();
  }

  render() {
    let shimmer = (
      <Shimmer>
        <div
          style={{
            width: "3ch",
            height: "1rem",
            verticalAlign: "middle",
          }}
        ></div>
      </Shimmer>
    );

    var columns = [
      // {
      //   key: "special_allowance_summary_employee_nip",
      //   text: "Pegawai",
      //   sortable: true,
      //   cell: (record) => {
      //     var plt = record.special_allowance_summary_plt_position_uuid;
      //     return (
      //       <span>
      //         <strong>{record.special_allowance_summary_employee_nip}</strong>
      //         <br></br>
      //         {record.special_allowance_summary_employee_name}
      //         <br></br>
      //         {/* {plt != null && plt != "" ? "Plt. " : ""} */}
      //         {record.special_allowance_summary_employee_current_position_name ? (
      //           <>
      //             {
      //               record.special_allowance_summary_employee_current_position_name
      //             }
      //           </>
      //         ) : (
      //           <>
      //             <span style="color:red">
      //               {record.special_allowance_summary_skp_position_name}
      //             </span>
      //           </>
      //         )}
      //       </span>
      //     );
      //   },
      // },
      {
        key: "special_allowance_summary_employee_nip",
        text: "Pegawai",
        sortable: true,
        cell: (record) => {
          var plt = record.special_allowance_summary_plt_position_uuid;
          const uuid = record.special_allowance_uuid;
          let data_status = record.special_allowance_status
            ? record.special_allowance_status
            : 0;
          const newLocal = this;
          return (
            <span>
              <strong>{record.special_allowance_summary_employee_nip}</strong>
              <br></br>
              {record.special_allowance_summary_employee_name}
              <br></br>
              {/* {plt != null && plt != "" ? "Plt. " : ""} */}
              {record.special_allowance_summary_employee_current_position_name ? (
                <>
                  {
                    record.special_allowance_summary_employee_current_position_name
                  }

                  {accessRole("create") &&
                    // data_status === 0
                    this.props.additionalFilter.statusVerifikasi == 0 &&
                    newLocal.state.roleId == 1 ? (
                    <span>
                      {" "}
                      <button
                        className="btn btn-danger btn-sm"
                        id={"deleteData-" + uuid}
                        onClick={() => {
                          this.setState({
                            submitType: 2,
                            special_uuid: uuid,
                            summary_uuid: record.special_allowance_summary_uuid,
                            posiiton_name:
                              record.special_allowance_summary_employee_current_position_name,
                            selectedEmployeeNip:
                              record.special_allowance_summary_employee_nip,
                            selectedEmployeeName:
                              record.special_allowance_summary_employee_name,
                            confirm: true,
                            confirmInfo:
                              "Apakah anda yakin akan menghapus data atas nama <b>" +
                              record.special_allowance_summary_employee_name +
                              (record.special_allowance_summary_employee_current_position_name
                                ? " ( " +
                                record.special_allowance_summary_employee_current_position_name +
                                " )"
                                : " ( - )") +
                              "</b> ini?",
                          });
                          // this.toggleModal();
                        }}
                        style={{
                          marginRight: "2px",
                          padding: "2px 5px",
                        }}
                      >
                        <i className="uil-trash"></i>
                      </button>
                      <Tooltip
                        style={{
                          marginBottom: 2,
                        }}
                        placement="top"
                        isOpen={this.state["deleteData" + uuid]}
                        target={"deleteData-" + uuid}
                        toggle={() => {
                          this.setState({
                            ["deleteData" + uuid]:
                              !this.state["deleteData" + uuid],
                          });
                        }}
                      >
                        Hapus Penilaian
                      </Tooltip>
                    </span>
                  ) : null}
                </>
              ) : (
                <>
                  <span style={{ color: "red" }}>
                    {record.special_allowance_summary_skp_position_name}
                  </span>{" "}
                  {/* <br></br> */}
                  {this.state.roleId == 1 ? (
                    <>
                      <span>
                        <button
                          className="btn btn-primary btn-sm"
                          id={"updatePos-" + uuid}
                          onClick={() => {
                            this.setState({
                              submitType: 1,
                              confirm: true,
                              confirmInfo:
                                "Apakah anda yakin akan mengubah jabatan ini?",
                              updatePositionUuid: uuid,
                              selectedPositionSKP:
                                record.special_allowance_summary_skp_position_name,
                              selectedEmployeeNip:
                                record.special_allowance_summary_employee_nip,
                              selectedEmployeeNip:
                                record.special_allowance_summary_employee_nip,
                              selectedEmployeeName:
                                record.special_allowance_summary_employee_name,
                            });
                            this.toggleModal();
                          }}
                          style={{
                            marginRight: "2px",
                            padding: "2px 5px",
                          }}
                        >
                          <i className="uil-pen"></i>
                          {/* Ubah Jabatan */}
                        </button>
                        <Tooltip
                          style={{
                            marginBottom: 2,
                          }}
                          placement="top"
                          isOpen={this.state["updatePos" + uuid]}
                          target={"updatePos-" + uuid}
                          toggle={() => {
                            this.setState({
                              ["updatePos" + uuid]:
                                !this.state["updatePos" + uuid],
                            });
                          }}
                        >
                          Ubah Jabatan
                        </Tooltip>
                      </span>
                    </>
                  ) : null}
                </>
              )}

              {record.special_allowance_summary_paid_leave_notes ? (
                <>
                  <br></br>
                  <span
                    style={{
                      color: "red",
                      fontSize: "0.85rem",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: `(${record.special_allowance_summary_paid_leave_notes})`,
                    }}
                  ></span>{" "}
                </>
              ) : null}

              {record.special_allowance_summary_punishment_discipline_notes ? (
                <>
                  <br></br>
                  <span
                    style={{
                      color: "red",
                      fontSize: "0.85rem",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: `(${record.special_allowance_summary_punishment_discipline_notes})`,
                    }}
                  ></span>{" "}
                </>
              ) : null}
            </span>
          );
        },
      },

      {
        key: "special_allowance_summary_emp_grade_tunsus",
        text: "Grade",
        sortable: true,
        align: "center",
        cell: (record) => {
          return (
            <Fragment>
              {record.special_allowance_summary_emp_grade_tunsus ? (
                record.special_allowance_summary_emp_grade_tunsus
              ) : (
                <label className="badge rounded-pill bg-soft-danger font-size-12">
                  Belum Mapping Grade
                </label>
              )}
            </Fragment>
          );
        },
      },

      {
        key: "special_allowance_summary_presensi",
        // text:
        //   this.state.loadingTable === false ? (
        //     `Presensi \n (Bobot ${this.props.additionalFilter.presensi}%)`
        //   ) : (
        //     <Fragment>Presensi (Bobot {shimmer}%)</Fragment>
        //   ),
        sortable: true,
        align: "center",
        header: () => {
          return (
            <div className="text-center">
              Presensi
              <br />
              (Bobot{" "}
              {this.state.loadingTable === false
                ? this.props.additionalFilter.presensi
                : shimmer}
              %)
            </div>
          );
        },
        cell: (record) => {
          return (
            <span
              style={{ cursor: "pointer", color: "blue", textDecoration: "underline" }}
              onClick={() => {
                this.setState({
                  modalPresensi: true,
                  modalPresensiUuid: record.special_allowance_summary_employe_uuid,
                  modalPresensiFilter: (() => {
                    let m = parseInt(record.special_allowance_summary_month) - 1;
                    let y = parseInt(record.special_allowance_summary_year);
                    if (m === 0) {
                        m = 12;
                        y = y - 1;
                    }
                    let mStr = m.toString().padStart(2, '0');
                    return {
                        start_date: moment(y + "-" + mStr + "-01").startOf('month').format('YYYY-MM-DD'),
                        end_date: moment(y + "-" + mStr + "-01").endOf('month').format('YYYY-MM-DD')
                    };
                  })()
                });
              }}
            >
              {record.special_allowance_summary_presensi
                ? record.special_allowance_summary_presensi
                : "-"}
              <br></br>(
              {record.special_allowance_summary_akumulasi_presensi
                ? record.special_allowance_summary_akumulasi_presensi
                : "-"}
              )
            </span>
          );
        },
      },

      // {
      //   key: "special_allowance_summary_punishment_discipline",
      //   text: "Hukuman Disiplin",
      //   sortable: true,
      //   align: "center",
      //   cell: (record) => {
      //     return (
      //       <Fragment>
      //         {record.special_allowance_summary_punishment_discipline
      //           ? record.special_allowance_summary_punishment_discipline + "%"
      //           : "-"}
      //       </Fragment>
      //     );
      //   },
      // },

      {
        key: "special_allowance_summary_skp",
        // text:
        //   this.state.loadingTable === false ? (
        //     `Penilaian Kinerja Individu \n (Bobot ${this.props.additionalFilter.skp}%)`
        //   ) : (
        //     <Fragment>Penilaian Kinerja Individu (Bobot {shimmer}%)</Fragment>
        //   ),
        sortable: true,
        align: "center",
        header: () => {
          return (
            <div className="text-center">
              Penilaian Kinerja Individu
              <br />
              (Bobot{" "}
              {this.state.loadingTable === false
                ? this.props.additionalFilter.skp
                : shimmer}
              %)
            </div>
          );
        },
        cell: (record) => {
          return (
            <Fragment>
              {record.special_allowance_summary_skp
                ? record.special_allowance_summary_skp
                : "-"}
              <br></br>(
              {record.special_allowance_summary_final_result
                ? record.special_allowance_summary_final_result
                : "-"}
              )
            </Fragment>
          );
        },
      },

      {
        key: "special_allowance_summary_penilaian_pimpinan",
        // text:
        //   this.state.loadingTable === false ? (
        //     `Ekspektasi Pimpina \n (Bobot ${this.props.additionalFilter.penilaian}%)`
        //   ) : (
        //     <Fragment>Ekspektasi Pimpina (Bobot {shimmer}%)</Fragment>
        //   ),
        className: "text-center",
        // width: 120,
        sortable: true,
        align: "center",
        header: () => {
          return (
            <div className="text-center">
              Ekspektasi Pimpinan
              <br />
              (Bobot{" "}
              {this.state.loadingTable === false
                ? this.props.additionalFilter.penilaian
                : shimmer}
              %)
            </div>
          );
        },
        cell: (record) => {
          const thisId = record.special_allowance_uuid;
          let data_status = record.special_allowance_status
            ? record.special_allowance_status
            : 0;
          let categories_uuid =
            record.special_allowance_summary_employee_categories_uuid
              ? record.special_allowance_summary_employee_categories_uuid
              : "";
          let nip = record.special_allowance_summary_employee_nip
            ? record.special_allowance_summary_employee_nip
            : "";
          let position_uuid = record.special_allowance_summary_plt_position_uuid
            ? record.special_allowance_summary_plt_position_uuid
            : record.special_allowance_summary_employee_current_position_uuid;
          let employee_uuid = record.special_allowance_summary_employe_uuid
            ? record.special_allowance_summary_employe_uuid
            : null;
          let status_cuti = record.special_allowance_summary_paid_leave_status;

          return (
            <Fragment>
              {record.special_allowance_summary_penilaian_pimpinan
                ? record.special_allowance_summary_penilaian_pimpinan
                : "-"}
              <br></br>
              {/* Beri Nilai  */}
              {
                // untuk eselon 1 & 2
                (accessRole("create") &&
                  data_status === 0 &&
                  this.state.roleId == 2 &&
                  this.props.additionalFilter.is_eselon == 1 &&
                  this.props.additionalFilter.statusVerifikasi == 0 &&
                  this.props.additionalFilter.configPenilaian == 1 &&
                  status_cuti == 1) ||
                  // untuk administrator
                  (accessRole("create") &&
                    data_status === 0 &&
                    this.state.loadingTable == false &&
                    this.state.roleId == 1 &&
                    this.props.additionalFilter.statusVerifikasi == 0 &&
                    status_cuti == 1) ? (
                  // this.props.additionalFilter.configPenilaian == 1 &&
                  // (this.state.categories.includes(categories_uuid) ||
                  //   this.state.positions.includes(position_uuid) ||
                  //   this.props.additionalFilter.employee_uuids.includes(
                  //     employee_uuid

                  //   )))

                  <span>
                    <button
                      className="btn btn-success btn-sm"
                      id={"create-" + thisId}
                      onClick={() => {
                        this.setState({
                          createUuid: thisId,
                        });
                      }}
                      style={{
                        marginRight: "2px",
                        padding: "2px 5px",
                      }}
                    >
                      <i className="uil-check"></i> Beri Penilaian Bawahan
                    </button>
                    <Tooltip
                      style={{
                        marginBottom: 2,
                      }}
                      placement="top"
                      isOpen={this.state["create" + thisId]}
                      target={"create-" + thisId}
                      toggle={() => {
                        this.setState({
                          ["create" + thisId]: !this.state["create" + thisId],
                        });
                      }}
                    >
                      Beri Nilai
                    </Tooltip>
                  </span>
                ) : null
              }
              {/* Ubah Nilai  */}
              {
                // eselon 1 & 2
                (accessRole("update") &&
                  data_status === 1 &&
                  this.state.roleId == 2 &&
                  this.props.additionalFilter.is_eselon == 1 &&
                  this.props.additionalFilter.statusVerifikasi == 0 &&
                  status_cuti == 1) ||
                  // &&
                  // this.props.additionalFilter.configPenilaian == 1)
                  // this.props.additionalFilter.configPenilaian == 1 &&
                  // administrator
                  (accessRole("create") &&
                    data_status === 1 &&
                    this.state.loadingTable == false &&
                    this.state.roleId == 1 &&
                    this.props.additionalFilter.statusVerifikasi == 0 &&
                    status_cuti == 1) ? (
                  // &&
                  // this.props.additionalFilter.configPenilaian == 1 &&
                  // (this.state.categories.includes(categories_uuid) ||
                  //   this.state.positions.includes(position_uuid) ||
                  //   this.props.additionalFilter.employee_uuids.includes(
                  //     employee_uuid
                  //   )))

                  <span>
                    <button
                      className="btn btn-primary btn-sm"
                      id={"update-" + thisId}
                      onClick={() => {
                        this.setState({
                          updateUuid: thisId,
                        });
                      }}
                      style={{
                        marginRight: "2px",
                        padding: "2px 5px",
                      }}
                    >
                      <i className="uil-pen"></i> Ubah Penilaian Bawahan
                    </button>
                    <Tooltip
                      style={{
                        marginBottom: 2,
                      }}
                      placement="top"
                      isOpen={this.state["update" + thisId]}
                      target={"update-" + thisId}
                      toggle={() => {
                        this.setState({
                          ["update" + thisId]: !this.state["update" + thisId],
                        });
                      }}
                    >
                      Ubah Nilai
                    </Tooltip>
                    <br></br>
                    <button
                      className="btn btn-danger btn-sm mt-1"
                      id={"clear-" + thisId}
                      onClick={() => {
                        this.setState({
                          confirm: true,
                          submitType: 3,
                          confirmInfo: "Apakah anda yakin ingin menghapus data penilaian ini?",
                          special_uuid: thisId
                        });
                      }}
                      style={{
                        marginRight: "2px",
                        padding: "2px 5px",
                      }}
                    >
                      <i className="uil-trash"></i> Hapus Hasil Penilaian
                    </button>
                    <Tooltip
                      style={{
                        marginBottom: 2,
                      }}
                      placement="top"
                      isOpen={this.state["clear" + thisId]}
                      target={"clear-" + thisId}
                      toggle={() => {
                        this.setState({
                          ["clear" + thisId]: !this.state["clear" + thisId],
                        });
                      }}
                    >
                      Hapus Hasil Penilaian
                    </Tooltip>
                  </span>
                ) : null
              }
              {/* Preview   */}
              {/* ( accessRole("update") &&
                data_status === 1 &&
                this.state.loadingTable == false &&
                this.state.roleId == 1
                &&
                !this.state.categories.includes(categories_uuid))

                   ||

                  (accessRole("update") &&
                    data_status === 1 &&
                    this.state.roleId == 2 &&
                    this.props.additionalFilter.is_eselon == 0) */}
              {/* // eselon 1 & 2 */}
              {accessRole("read") &&
                (data_status === 1 &&
                  this.props.additionalFilter.statusVerifikasi) == 1 ? (
                <span>
                  <button
                    className="btn btn-primary btn-sm"
                    id={"preview-" + thisId}
                    onClick={() => {
                      this.setState({
                        previewUuid: thisId,
                      });
                    }}
                    style={{
                      marginRight: "2px",
                      padding: "2px 5px",
                    }}
                  >
                    <i className="uil-eye"></i> Lihat Hasil Penilaian
                  </button>
                  <Tooltip
                    style={{
                      marginBottom: 2,
                    }}
                    placement="top"
                    isOpen={this.state["preview" + thisId]}
                    target={"preview-" + thisId}
                    toggle={() => {
                      this.setState({
                        ["preview" + thisId]: !this.state["preview" + thisId],
                      });
                    }}
                  >
                    Lihat Hasil Penilaian
                  </Tooltip>
                </span>
              ) : null}
            </Fragment>
          );
        },
      },
      {
        key: "special_allowance_summary_total",
        text: "Nilai Akhir",
        sortable: true,
        align: "center",
        cell: "-",
      },
      // {
      //     key: "special_allowance_summary_status",
      //     text: "Status",
      //     sortable: true,
      //     cell: record => (record.special_allowance_summary_status === 1) ? <label className="badge rounded-pill bg-soft-info font-size-12" >Aktif</label> : <label className="badge rounded-pill bg-soft-warning font-size-12" >Nonaktif</label>
      // },
    ];
    return (
      <>
        <Modal isOpen={this.state.modalPresensi} toggle={() => this.setState({ modalPresensi: false })} size="xl" style={{ maxWidth: '95vw' }}>
          <ModalHeader toggle={() => this.setState({ modalPresensi: false })}>Detail Presensi</ModalHeader>
          <ModalBody style={{ padding: '10px', height: '80vh', overflowY: 'auto' }}>
            {this.state.modalPresensi && this.state.modalPresensiUuid ? (
              <SimulationComponent 
                uuid={this.state.modalPresensiUuid} 
                filter={this.state.modalPresensiFilter} 
                handleInactiveSuccess={() => {}}
              />
            ) : null}
          </ModalBody>
        </Modal>
        <MKIDatatable
          className={this.configDatatable.tableClass}
          config={this.configDatatable}
          records={this.state.rows}
          columns={columns}
          dynamic={true}
          minWidth={1000}
          total_record={this.state.totalRow}
          initial={this.state.filter}
          onChange={(filter) => {
            this.setState(
              {
                loadingTable: true,
                filter: filter,
              },
              function () {
                this.setTokenAPI();
              }
            );
          }}
          loading={this.state.loadingTable}
        />
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          // confirmInfo={`Apakah anda yakin akan mengubah jabatan ini?`}
          confirmInfo={this.state.confirmInfo}
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil diubah"
          failedTitle="Gagal!"
          failedInfo="Data gagal diubah"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />

        <Modal
          size="lg"
          isOpen={this.state.modal}
          toggle={() => this.toggleModal()}
        >
          <ModalHeader toggle={() => this.toggleModal()}>
            Ubah Jabatan
          </ModalHeader>
          <AvForm
            className="needs-validation"
            onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
          >
            <ModalBody>
              <Row className="mb-3">
                <Label className="col-md-4 col-form-label">Nama</Label>
                <Col md="8">
                  <AvField
                    name="position_name"
                    placeholder="Nama Jabatan"
                    errorMessage="Masukkan Nama Jabatan"
                    type="text"
                    className="form-control"
                    value={this.state.selectedEmployeeName}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Label className="col-md-4 col-form-label">NIP</Label>
                <Col md="8">
                  <AvField
                    name="position_name"
                    placeholder="Nama Jabatan"
                    errorMessage="Masukkan Nama Jabatan"
                    type="text"
                    className="form-control"
                    value={this.state.selectedEmployeeNip}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Label className="col-md-4 col-form-label">
                  Jabtan dari SKP
                </Label>
                <Col md="8">
                  <AvField
                    name="position_name"
                    placeholder="Nama Jabatan"
                    errorMessage="Masukkan Nama Jabatan"
                    type="text"
                    className="form-control"
                    value={this.state.selectedPositionSKP}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Label className="col-md-4 col-form-label">
                  Jabatan <span className="text-danger">*</span>
                </Label>
                <Col md="8">
                  <Select
                    // selectedPosition
                    onChange={(v) => {
                      this.setState({
                        selectedPositionUuid: v.position_uuid,
                        selectedPositionName: v.position_name,
                      });
                    }}
                    name="selecetd_position_uuid"
                    errorMessage="Pilih Jabatan"
                    options={this.state.positionOptions}
                    optionLabel="position_name"
                    optionValue="position_uuid"
                    placeholder="Pilih Jabatan"
                    validate={{ required: { value: true } }}
                  />
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button color="primary" type="submit">
                Submit
              </Button>{" "}
              <Button onClick={() => this.toggleModal()}>Cancel</Button>
            </ModalFooter>
          </AvForm>
        </Modal>

        {this.state.createUuid !== null ? (
          <Redirect
            to={
              "/kepegawaian/penilaian_tunjangan_khusus.html?create_assestment&uuid=" +
              this.state.createUuid
            }
          />
        ) : null}
        {this.state.updateUuid !== null ? (
          <Redirect
            to={
              "/kepegawaian/penilaian_tunjangan_khusus.html?update_assestment&uuid=" +
              this.state.updateUuid
            }
          />
        ) : null}

        {this.state.previewUuid !== null ? (
          <Redirect
            to={
              "/kepegawaian/penilaian_tunjangan_khusus.html?preview_assestment&uuid=" +
              this.state.previewUuid
            }
          />
        ) : null}
      </>
    );
  }
}

export default TablePenilaianBawahanComponent;
